/* eslint-disable */
import VideoEvents from "./VideoEvents";
import {Video, VideoChangeSet,AddVideoInfo, EditVideoInfo, UploadDocumentIF, VideoPDF, UpdateVideoSlideIF} from "./models/Video";
import {VideoReaction, VideoReactionChangeSet} from "./models/VideoReaction";
import {VideoCaption} from "./models/VideoCaption";
import {VideoComment, VideoCommentChangeSet} from "./models/VideoComment";
import {VideoExtraMaterial} from "./models/VideoExtraMaterial";
import {FilterResult, VideoFilter} from "./models/VideoFilter";

export const loadVideoList = () => ({
    type: VideoEvents.LoadVideoListStarted
} as const);

export const loadVideoListComplete = (videos: Video[]) => ({
    type: VideoEvents.LoadVideoListComplete,
    videos
} as const);

export const loadVideoStarted = (videoId: number | string, userId: string) => ({
    type: VideoEvents.LoadVideoStarted,
    videoId, userId
} as const);

export const loadVideoComplete = (video: Video) => ({
    type: VideoEvents.LoadVideoComplete,
    video
} as const);

export const createVideo = (formData: FormData) => ({
    type: VideoEvents.CreateStarted,
    formData
} as const);

export const uploadExtraMaterial = (videoId: number, formData: FormData) => ({
    type: VideoEvents.UploadExtraMaterials,
    videoId, formData
} as const);

export const uploadExtraMaterialComplete = (material: VideoExtraMaterial) => ({
    type: VideoEvents.UploadExtraMaterialsComplete,
    material
} as const);

export const deleteExtraMaterial = (videoId: number, materialId: number) => ({
    type: VideoEvents.DeleteExtraMaterials,
    videoId, materialId
} as const);

export const createVideoComplete = () => ({
    type: VideoEvents.CreateComplete
} as const);

export const updateVideo = (videoId: number, changeSet: VideoChangeSet) => ({
    type: VideoEvents.Update,
    videoId, changeSet
} as const);

export const deleteVideo = (videoId: number) => ({
    type: VideoEvents.Delete,
    videoId
} as const);
// 視聴履歴登録
export const AddViewingHistory = (userId: string, videoId: number, progressMillis: number) => ({
    type: VideoEvents.AddViewingHistory,
    userId,
    videoId,
    progressMillis
} as const);
export const incrementVideoViewCount = (userId: string, videoId: number) => ({
    type: VideoEvents.IncrementViewCount,
    userId,
    videoId
} as const);

export const addVideoReaction = (videoReactionChangeSet: VideoReactionChangeSet) => ({
    type: VideoEvents.ReactStarted,
    videoReactionChangeSet
} as const);

export const addVideoReactionComplete = (reaction: VideoReaction) => ({
    type: VideoEvents.ReactComplete,
    reaction
} as const);

export const createVideoComment = (videoCommentChangeSet: VideoCommentChangeSet) => ({
    type: VideoEvents.CommentStarted,
    videoCommentChangeSet
} as const);

export const createVideoCommentComplete = (comment: VideoComment) => ({
    type: VideoEvents.CommentComplete,
    comment
} as const);

export const filterVideoList = (id: string, filters: VideoFilter) => ({
    type: VideoEvents.filterVideoListStarted,
    userId: id,
    filters
} as const);

export const filterVideoListComplete = (filterResult: FilterResult) => ({
    type: VideoEvents.filterVideoListComplete,
    filterResult
} as const);

export const getTagList = (tagInput: string[]) => ({
    type: VideoEvents.getTagListStarted,
    tagInput
} as const);

export const getTagListComplete = (tagOutput: string[]) => ({
    type: VideoEvents.getTagListComplete,
    tagOutput
} as const);

// ビデオ追加
export const AddVideo = (video: AddVideoInfo) => ({
    type: VideoEvents.AddVideoStarted,
    video
} as const);

export const AddVideoComplete = () => ({
    type: VideoEvents.AddVideoComplete
} as const);

export const AddVideoFailed = () => ({
    type: VideoEvents.AddVideoFailed
} as const);


// ビデオ編集
export const EditVideo = (editVideo: EditVideoInfo) => ({
    type: VideoEvents.EditVideoStarted,
    editVideo
} as const);

export const EditVideoComplete = (updateVideo: Video) => ({
    type: VideoEvents.EditVideoComplete,
    updateVideo
} as const);

export const EditVideoFailed = (videoId: number) => ({
    type: VideoEvents.EditVideoFailed,
    videoId
} as const);

// ビデオ資料アップロード
export const UploadDocument = (document: UploadDocumentIF) => ({
    type: VideoEvents.UploadDocumentStarted,
    document
} as const);

export const UploadDocumentComplete = (document: VideoExtraMaterial) => ({
    type: VideoEvents.UploadDocumentComplete,
    document
} as const);

export const UploadDocumentFailed = () => ({
    type: VideoEvents.UploadDocumentFailed
} as const);

// ビデオ削除
export const DeleteVideo = (videoId: number) => ({
    type: VideoEvents.DeleteVideoStarted,
    videoId
} as const);

export const DeleteVideoComplete = () => ({
    type: VideoEvents.DeleteVideoComplete
} as const);

export const DeleteVideoFailed = () => ({
    type: VideoEvents.DeleteVideoFailed
} as const);

// ビデオデータリセット
export const ResetVideos = () => ({
    type: VideoEvents.ResetVideos
} as const);
export const ResetVideo = () => ({
    type: VideoEvents.ResetVideo
} as const);

// ビデオスライド資料取得
export const GetVideoSlide = (videoId: string, fileId: string) => ({
    type: VideoEvents.GetVideoSlide,
    videoId,fileId
} as const);
export const GetVideoSlideComplete = (videoPdf: VideoPDF) => ({
    type: VideoEvents.GetVideoSlideComplete,
    videoPdf
} as const);

// ビデオスライド資料追加
export const UploadVideoSlide = (uploadVideoSlide: UpdateVideoSlideIF) => ({
    type: VideoEvents.UploadVideoSlideStarted,
    uploadVideoSlide
} as const);

export const UploadVideoSlideFailed = () => ({
    type: VideoEvents.UploadVideoSlideFailed
} as const);

export const UploadVideoSlideComplete = (videoSlide: VideoPDF) => ({
    type: VideoEvents.UploadVideoSlideComplete,
    videoSlide
} as const);

// ビデオスライド資料編集
export const EditVideoSlide = (editVideoSlide: UpdateVideoSlideIF) => ({
    type: VideoEvents.EditVideoSlideStarted,
    editVideoSlide
} as const);

export const EditVideoSlideFailed = () => ({
    type: VideoEvents.EditVideoSlideFailed
} as const);

export const EditVideoSlideComplete = (videoId: number,videoSlide: VideoPDF) => ({
    type: VideoEvents.EditVideoSlideComplete,
    videoId,
    videoSlide
} as const);

// ビデオスライド資料削除
export const DeleteVideoSlide = (videoId: number) => ({
    type: VideoEvents.DeleteVideoSlideStarted,
    videoId
} as const);

export const DeleteVideoSlideFailed = () => ({
    type: VideoEvents.DeleteVideoSlideFailed
} as const);

export const DeleteVideoSlideComplete = (videoId: number) => ({
    type: VideoEvents.DeleteVideoSlideComplete,
    videoId
} as const);

// ローディング表示
export const VisibleLoading = () => ({
    type: VideoEvents.VisibleLoading
} as const);

export const InvisibleLoading = () => ({
    type: VideoEvents.InvisibleLoading
} as const);

/**
 * ビデオの字幕情報取得スタートアクション
 * 
 * @param videoId ビデオID
 * @param language 言語
 * @returns ビデオの字幕情報取得スタート
 */
export const GetVideoCurrentSubtitleStarted = (videoId: number, language: string) => ({
    type: VideoEvents.GetVideoCurrentSubtitleStarted,
    videoId, language
} as const);

/**
 * ビデオの字幕情報取得完了アクション
 * 
 * @param subtitles 字幕情報
 * @returns 　字幕情報
 */
export const GetVideoCurrentSubtitleComplete = (language: string, captions: VideoCaption[]) => ({
    type: VideoEvents.GetVideoCurrentSubtitleComplete,
    language, captions
} as const);

/**
 * 最新字幕リストを更新する。
 * 
 * @param captions 字幕リスト
 * @returns 字幕更新結果
 */
export const SetCurrentVideoCaptions = (captions: VideoCaption[]) => ({
    type: VideoEvents.SetCurrentVideoCaptions,
    captions
} as const);
